import { Avatar, MediaObject, Paragraph } from '@zillow/constellation-10';
import type { InviteGuarantorWebApiResponseDto } from '@zg-rentals/ts-capps-client';

export function GuarantorSummary({ guarantor }: { guarantor: InviteGuarantorWebApiResponseDto }) {
  return (
    <MediaObject
      media={<Avatar fullName={`${guarantor.firstName} ${guarantor.lastName}`} tone="accent-1" size="sm" />}
      css={{ alignItems: 'center' }}
    >
      <Paragraph textStyle="body-sm-bold">
        {guarantor.firstName} {guarantor.lastName}
      </Paragraph>
      <Paragraph textStyle="body-xs" css={{ color: 'text.subtle' }}>
        {guarantor.email}
      </Paragraph>
    </MediaObject>
  );
}
